import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveBusinessTripConfiguration } from './saveBusinessTripConfiguration';
import { BusinessTripConfigurationModel } from './types';
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { QUERY_KEY_SETTINGS_BUSINESS_TRIP } from '@/lib/api/constants';

export function useConfigurationBusinessTripMutation(companyId: string) {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async (payload: BusinessTripConfigurationModel) => {
            if (COMPANY_API_SETTINGS_MOCKED) {
                return true
            }
            const { data } = await saveBusinessTripConfiguration({ companyId, payload })
            return data;
        },

        onError: (error) => {
            // @TODO handle error properly
            // show notification to user
            // @TODO display notification
            console.error('Error useConfigurationBusinessTripMutation:', error);
        },

        onSuccess: (saved) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SETTINGS_BUSINESS_TRIP, companyId] });
        },
    });
}
